<!--
 * @Author: zzz
 * @Date: 2021-02-06 22:10:33
 * @LastEditTime: 2021-02-11 21:20:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \04eos-app\src\pages\testDrive\day\index.vue
-->
<template>
  <div id="Day"></div>
</template>
<script>
/* eslint-disable */
import Calendar from 'tui-calendar'
import { Theme, StateColors } from './config'
import 'tui-calendar/dist/tui-calendar.min.css'
export default {
  name: 'CalendarDay',
  props: {
    schedules: {
      type: Array,
      require: true
    },
    start: {
      type: String,
      require: true
    }
  },
  watch: {
    'schedules': {
      handler () {
        this.calendarData = JSON.parse(JSON.stringify(this.schedules))
        // 增加日程
        this.schedulePush(this.calendarData)
      },
      immediately: true,
      deep: true
    },
    'start': {
      handler () {
        window.day.setDate((`${this.start} 00:00:00`))
        window.day.render()
      },
      immediately: true,
      deep: true
    },
  },
  data () {
    return {
      day: {},
      calendarData: []
    }
  },
  methods: {
    // 渲染日历
    calendarInit () {
      return new Calendar('#Day', {
        id: 'calendarDay',
        defaultView: 'day',
        scheduleView: ['time'],
        isReadOnly: true,
        theme: Theme,
        immediately: true,
        taskView: [],
        template: {
          timegridDisplayPrimaryTime: function (time) {
            var hour = time.hour + ':00'
            return hour
          },
          time: function (schedule) {
            return schedule.title
          },
          task: function (schedule) {
            return `${schedule.title}`
          },
          taskTitle: function () {
            return ''
          }
        },
        week: {
          daynames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
          timegridCurrentTime: false,
          startDayOfWeek: 0,
          narrowWeekend: true,
          workweek: false,
          showTimezoneCollapseButton: true,
          timezonesCollapsed: true,
          hourStart: 8,
          hourEnd: 21
        }
      }
      )
    },
    // 添加日程
    schedulePush (calendarData) {

      // 根据状态设置日历颜色
      this.calendarData.forEach(e => {
        window.day.setCalendarColor(e.calendarId, {
          color: '#FFF',
          bgColor: StateColors[`${e.state}`],
          borderColor: StateColors[`${e.state}`],
          dragBgColor: '#FFF'
        })
      })
      window.day.clear();
      window.day.createSchedules(calendarData)
      // 色块的点击事件
      window.day.on("clickSchedule", (event) => {
        const schedule = event.schedule;
        const item = calendarData.filter((el) => {
          return el.id === schedule.id;
        });
        if (item.length !== 0) {
          console.log('item', item);

          this.$router.push({
            path: '/testDriveDetail',
            query: {
              'id': item[0].eosTestDriveId
            }
          })
        }


      });
    }
  },
  mounted () {
    window.day = this.calendarInit()
  }
}
</script>
<style lang="less">
@import "./index.less";
</style>